/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { get as _get } from 'lodash-es';

import React, { useRef } from 'react';
import { IoMdArrowForward, IoMdArrowBack } from 'react-icons/io';
import { getSlugName } from '../helpers/util';
import useCaseStudies from '../graphql/staticQueries/useCaseStudies';
import Carousel from './Carousels/SingleItemFadeCarousel';
import ResultItem from './Results/resultsPartials/ResultItem';

const ResultsBeam = ({
  title,
  buttonsAround,
  className,
  omitByID,
  allCases,
  category,
  ignoredCategories,
  useSpecificCases,
  onlySlider
}) => {
  const sliderRef = useRef(null);
  const goNext = () => {
    if (sliderRef !== null) {
      sliderRef.current.next();
    }
  };
  const goPrev = () => {
    if (sliderRef !== null) {
      sliderRef.current.prev();
    }
  };
  const Buttons = (
    <div className="navigation-slider xs-left">
      <div
        className="nav-button nav-left"
        aria-label="Show previous card"
        role="button"
        onClick={goPrev}
        tabIndex="0"
      >
        <IoMdArrowBack />
      </div>
      <div
        className="nav-button nav-right"
        aria-label="Show next card"
        role="button"
        onClick={goNext}
        tabIndex="0"
      >
        <IoMdArrowForward />
      </div>
    </div>
  );

  const ignoredCategoriesUpper = ignoredCategories.map(c => c.toUpperCase());

  let cases = allCases;
  if (useSpecificCases) {
    cases = cases.filter(caseStudy => {
      const slug = getSlugName(caseStudy);
      return useSpecificCases.includes(slug);
    });
  } else {
    cases = cases.filter(caseStudy => {
      if (caseStudy.id === omitByID) return false;
      const caseCategory = _get(
        caseStudy,
        'frontmatter.info.industry'
      ).toUpperCase();
      if (category !== 'ALL') {
        return caseCategory === category.toUpperCase();
      }
      if (
        ignoredCategoriesUpper.length > 0 &&
        ignoredCategoriesUpper.includes(caseCategory)
      ) {
        return false;
      }
      return true;
    });
  }
  return (
    <div className={`results-beam ${className}`}>
      {!onlySlider && (
        <div className="container">
          <div className="main-title link-area">
            <div className="tt">{title}</div>
            <div className="dd">Here’s how we solved our client’s problems</div>
            <Link to="/case-studies/" className="btn btn-main">
              Go to case studies
            </Link>
          </div>
        </div>
      )}

      <div className="container">
        <div className="result-slider main-swiper">
          <Carousel ref={sliderRef}>
            {cases.map(caseStudy => (
              <div
                className="slick-slider swiper-container swiper-result"
                key={caseStudy.id}
              >
                <ResultItem caseStudy={caseStudy} disableLinkOnSwipe />
              </div>
            ))}
          </Carousel>
          {cases.length > 1 ? !buttonsAround && <>{Buttons}</> : null}
          {buttonsAround && Buttons}
          <div className="swiper-pagination sw-pv1" />
        </div>
      </div>
      {!onlySlider && (
        <div className="container">
          <div className="mobile-area xs-right">
            <Link to="/case-studies/" className="btn btn-main">
              Go to case studies
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

const ResultsBeamData = props => {
  const cases = useCaseStudies();
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ResultsBeam {...props} allCases={cases} />
  );
};

export default ResultsBeamData;

ResultsBeam.defaultProps = {
  title: 'Results',
  buttonsAround: true,
  className: 'main-home-beam',
  omitByID: '',
  category: 'ALL',
  ignoredCategories: []
};

ResultsBeam.propTypes = {
  title: PropTypes.string,
  buttonsAround: PropTypes.bool,
  className: PropTypes.string,
  omitByID: PropTypes.string,
  category: PropTypes.string,
  ignoredCategories: PropTypes.arrayOf(PropTypes.string)
};
